import http from '@/utils/request'
import { MutationResult } from '@/types/common'
import { HolidayItem, HolidayUpsertPayload } from '../types'

const holidayApi = {
  async getYear(year: number): Promise<HolidayItem[]> {
    const res = await http.get<HolidayItem[]>(`/holidays/year/${year}`)
    return res.data || []
  },

  async create(payload: HolidayUpsertPayload): Promise<MutationResult> {
    const res = await http.post<MutationResult>('/holidays', payload)
    return res.data
  },

  async update(
    id: number,
    payload: Partial<HolidayUpsertPayload>,
  ): Promise<MutationResult> {
    const res = await http.put<MutationResult>(`/holidays/${id}`, payload)
    return res.data
  },

  async batchDelete(ids: number[]): Promise<MutationResult> {
    const res = await http.post<MutationResult>('/holidays/batch-delete', { ids })
    return res.data
  },
}

export default holidayApi
